/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';

import './formTitle.scss';

const form = require('b_').with('form');

export const FormTitle = ({ title, mods, children }) => (
    <div className={form('title_wrapper', mods)}>
        <h2 className={form('title', { blue: true })}>{title}</h2>
        {children}
    </div>
);
